var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarGradingBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.82 3H19C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H5C4.86 21 4.73 20.99 4.6 20.97C4.21 20.89 3.86 20.69 3.59 20.42C3.41 20.23 3.26 20.02 3.16 19.78C3.06 19.54 3 19.27 3 19V5C3 4.72 3.06 4.46 3.16 4.23C3.26 3.99 3.41 3.77 3.59 3.59C3.86 3.32 4.21 3.12 4.6 3.04C4.73 3.01 4.86 3 5 3H9.18C9.6 1.84 10.7 1 12 1C13.3 1 14.4 1.84 14.82 3ZM11.25 3.5C11.25 3.91 11.59 4.25 12 4.25C12.41 4.25 12.75 3.91 12.75 3.5C12.75 3.09 12.41 2.75 12 2.75C11.59 2.75 11.25 3.09 11.25 3.5Z",
    fill: "#077CA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0059 8.90805L13.5985 13.1538H10.4134L12.0059 8.90805ZM14.1679 14.6923L14.8605 16.5237C14.9747 16.8077 15.2526 17 15.5591 17C15.9768 17 16.2908 16.662 16.3043 16.2803C16.3073 16.1827 16.2908 16.082 16.2517 15.9844L12.9825 7.66857C12.8217 7.26142 12.4371 7 12.0059 7C11.5747 7 11.1901 7.26142 11.0219 7.66857L7.75263 15.9844C7.56033 16.4697 7.9209 17 8.44374 17C8.75924 17 9.03719 16.8077 9.14386 16.5147L9.82896 14.6923H14.1679Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3857 8.71429V7.38571H18.7143C18.9267 7.38571 19.1 7.21237 19.1 7C19.1 6.78763 18.9267 6.61429 18.7143 6.61429H17.3857V5.28571C17.3857 5.07334 17.2124 4.9 17 4.9C16.7876 4.9 16.6143 5.07334 16.6143 5.28571V6.61429H15.2857C15.0733 6.61429 14.9 6.78763 14.9 7C14.9 7.21237 15.0733 7.38571 15.2857 7.38571H16.6143V8.71429C16.6143 8.92666 16.7876 9.1 17 9.1C17.2124 9.1 17.3857 8.92666 17.3857 8.71429Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarGradingBlue);
export default __webpack_public_path__ + "static/media/sidebar_grading_blue.9a1d43784c16e223e807d32a95f1548d.svg";
export { ForwardRef as ReactComponent };